import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../api";

const UserContext = createContext(null);

const LS_KEY = "pay10x.activeUserId";

export function UserProvider({ children }) {
  const [users, setUsers] = useState([]);
  const [activeUserId, setActiveUserId] = useState(null);
  const [demoMode, setDemoMode] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const list = await api.users();
        setUsers(list);
        const saved = localStorage.getItem(LS_KEY);
        const chosen = list.find((u) => u.id === saved) || list.find((u) => u.role === "customer");
        if (chosen) setActiveUserId(chosen.id);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const switchUser = useCallback((id) => {
    setActiveUserId(id);
    localStorage.setItem(LS_KEY, id);
  }, []);

  const activeUser = users.find((u) => u.id === activeUserId) || null;
  const isAdmin = activeUser?.role === "admin";

  return (
    <UserContext.Provider
      value={{
        users,
        activeUser,
        activeUserId,
        isAdmin,
        loading,
        switchUser,
        demoMode,
        setDemoMode,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export const useUser = () => useContext(UserContext);
